import { SupportTransactionServiceMock } from "./support_transaction.types";

export const mockSupportTransactionService = (): SupportTransactionServiceMock => ({
  fetchTransactions: jest.fn(),
  fetchEntityIds: jest.fn(),
  fetchDeviceIds: jest.fn(),
  fetchStatus: jest.fn(),
  fetchActualIds: jest.fn(),
});
